// Shop by wheel size (Zendesk #13076): bolt pattern, then diameter, width and offset.
// Powers every form[data-wheel-size-search] (home banner tab, results page filter). Plain JS, so it does not wait
// for the deferred jQuery, and every lookup is scoped to its own form: the vehicle form's global [name="..."]
// selectors (ymm-search.js) never see these fields.
(function () {
  const ENDPOINT = 'https://services.texastrucktire.com/api-wheel-size-search.php?token=ACI928CKDHX0SW5&mode=options';
  const ORDER = ['bolt', 'dia', 'width', 'offset'];
  const LISTS = { bolt: 'bolt_patterns', dia: 'diameters', width: 'widths', offset: 'offsets' };

  async function fetchOptions(choice) {
    const params = new URLSearchParams();
    Object.entries(choice).forEach(([name, value]) => { if (value) params.set(name, value); });
    try {
      const response = await fetch(ENDPOINT + '&' + params.toString());
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return await response.json();
    } catch (error) {
      console.error('Wheel size options are unavailable:', error);
      return null;
    }
  }

  // Replace a dropdown's options; keep `keep` selected when it is still offered
  function fill(select, items, keep) {
    select.innerHTML = '';
    select.add(new Option(select.dataset.placeholder, ''));
    (items || []).forEach((item) => select.add(new Option(item.label, item.value)));
    select.disabled = !(items && items.length);
    if (keep && Array.from(select.options).some((option) => option.value === keep)) select.value = keep;
  }

  function init(form) {
    const selects = {};
    ORDER.forEach((name) => { selects[name] = form.elements[name]; });
    const button = form.querySelector('button');
    let latest = 0;

    const syncButton = () => { button.disabled = !selects.bolt.value; };

    // Reload the lists after `changed` (null = all of them) from the choices up to and including it
    async function refresh(changed, restore = {}) {
      const level = changed ? ORDER.indexOf(changed) : -1;
      const choice = {};
      ORDER.forEach((name, i) => { if (i <= level && selects[name].value) choice[name] = selects[name].value; });
      ORDER.forEach((name, i) => { if (i > level) fill(selects[name], [], ''); });
      syncButton();
      if (changed === 'offset') return;

      const request = ++latest;
      const data = await fetchOptions(choice);
      if (request !== latest || !data) return; // a newer choice replaced this one, or the lookup failed
      ORDER.forEach((name, i) => { if (i > level) fill(selects[name], data[LISTS[name]], restore[name]); });
      syncButton();
    }

    ORDER.forEach((name) => selects[name].addEventListener('change', () => refresh(name)));

    // Only the chosen fields go in the URL; sorting carries over when searching again from the results page
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!selects.bolt.value) return;
      const params = new URLSearchParams();
      ORDER.forEach((name) => { if (selects[name].value) params.set(name, selects[name].value); });
      const action = new URL(form.action, window.location.origin);
      const sort = new URLSearchParams(window.location.search).get('sort_by');
      if (sort && action.pathname === window.location.pathname) params.set('sort_by', sort);
      window.location.href = action.pathname + '?' + params.toString();
    });

    // Start with the bolt patterns; on the results page, restore the searched size from the URL
    (async () => {
      const url = new URLSearchParams(window.location.search);
      const restore = {};
      ORDER.forEach((name) => { if (url.get(name)) restore[name] = url.get(name); });
      await refresh(null, restore);
      for (const name of ['bolt', 'dia', 'width']) {
        if (!selects[name].value) break;
        await refresh(name, restore);
      }
    })();
  }

  document.querySelectorAll('form[data-wheel-size-search]').forEach(init);
})();
